import TablePage from '@/found/components/table_page';

export default {
  extends: TablePage,
  data() {
    return {
      params: {

      },
    };
  },

  created() {
    this.getConfigList('main_list');
  },
  methods: {},
};
